import React from 'react';

import * as css from './css/header';
import { useHistory, withRouter } from 'react-router-dom';
import Router from 'router/router';
import { logoStyle } from "api/commonApi";
import { observer } from 'mobx-react';
import useMyStores from "@/hooks/useMyStores";

function Header(props) {

    const { className } = props;
    const history = useHistory()
    const { app } = useMyStores()
    return (
        <css.Header className={className}>
            <css.BgImg src={require('./img/bg.png')} />
            <css.Container>
                {app.logo && (
                    <img
                        src={app.logo}
                        style={{
                            ...logoStyle,
                            display: 'block',
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                            history.push({
                                pathname: Router.Home.path
                            });
                        }}
                    />
                )}
                <css.Ul>
                    <css.Li>
                        <css.LiIcon src={require('./img/quality.png')} />
                        <css.LiContent>
                            <css.LiTitle>正品承诺</css.LiTitle>
                            <css.LiSubTitle>正品保障 假一赔十</css.LiSubTitle>
                        </css.LiContent>
                    </css.Li>
                    <css.Li>
                        <css.LiIcon src={require('./img/return.png')} />
                        <css.LiContent>
                            <css.LiTitle>7天无忧退货</css.LiTitle>
                            <css.LiSubTitle>不满包退 售后无忧</css.LiSubTitle>
                        </css.LiContent>
                    </css.Li>
                    <css.Li>
                        <css.LiIcon src={require('./img/fast.png')} />
                        <css.LiContent>
                            <css.LiTitle>闪电发货</css.LiTitle>
                            <css.LiSubTitle>多仓直发 急速配送</css.LiSubTitle>
                        </css.LiContent>
                    </css.Li>
                    <css.Li>
                        <css.LiIcon src={require('./img/good.png')} />
                        <css.LiContent>
                            <css.LiTitle>权威荣誉</css.LiTitle>
                            <css.LiSubTitle>好评如潮 值得信赖</css.LiSubTitle>
                        </css.LiContent>
                    </css.Li>
                    <css.Li>
                        <css.LiIcon src={require('./img/low-price.png')} />
                        <css.LiContent>
                            <css.LiTitle>低价保障</css.LiTitle>
                            <css.LiSubTitle>确保低价 畅选无忧</css.LiSubTitle>
                        </css.LiContent>
                    </css.Li>
                </css.Ul>
            </css.Container>
        </css.Header>
    );
}

export default observer(Header);
